import { createContext, type ReactNode, useContext } from 'react';
import type { TileSource } from '@/shared/api';

/**
 * Подложка карт админки (MarketConfig `maps.fallback_tiles`, ТЗ GEO 5.12, BR-GEO-64): источники тайлов
 * по порядку и порог ошибок подряд до переключения на следующий. Берутся из `GET /admin/config`
 * (`maps`), провайдер ставит слой app; карта (`shared/map`, Leaflet) читает их, если источники не
 * переданы явно. Модуль без Leaflet — его можно подключать в оболочке, не утяжеляя её чанк.
 */
export interface MapTiles {
  sources: readonly TileSource[];
  errorThreshold: number;
}

/** Без конфигурации (тесты, экран до входа) — карта без подложки, порог BR-GEO-64 по умолчанию. */
export const NO_MAP_TILES: MapTiles = { sources: [], errorThreshold: 2 };

const MapTilesContext = createContext<MapTiles>(NO_MAP_TILES);

export function MapTilesProvider({ value, children }: { value: MapTiles; children: ReactNode }) {
  return <MapTilesContext.Provider value={value}>{children}</MapTilesContext.Provider>;
}

export function useMapTiles(): MapTiles {
  return useContext(MapTilesContext);
}
